<template>
  <v-dialog
    persistent
    v-model="dialog"
    @keydown.esc="dialog = false"
    width="850"
    scrollable
  >
    <v-form ref="form" @submit.prevent lazy-validation v-model="valid">
      <v-card class="elevation-3">
        <v-card-title class="primary text-h5 white--text">
          {{ modalText }}
        </v-card-title>
        <v-card-text class="pa-4">
          <v-row>
            <v-col sm="12">
              <BaseDatePickerWithText
                label="Effective Date mm/dd/yyyy"
                v-model="selectedExciseTaxRateToCounty.EffectiveDate"
                :rules="[(v) => !!v || 'required']"
              ></BaseDatePickerWithText>
            </v-col>
          </v-row>

          <v-row>
            <v-col sm="12">
              <LuCounty
                label="County"
                includeInactive
                v-model="selectedExciseTaxRateToCounty.CountyID"
                :rules="[(v) => !!v || 'required']"
              ></LuCounty>
            </v-col>
          </v-row>
          <v-row>
            <v-col sm="12">
              <LuExciseTaxRates
                label="Tax Rate"
                v-model="selectedExciseTaxRateToCounty.TaxRateID"
                :rules="[(v) => !!v || 'required']"
              ></LuExciseTaxRates>
            </v-col>
          </v-row>
          <v-row>
            <v-col sm="12">
              <LuExciseTaxTypes
                label="Tax Type"
                v-model="selectedExciseTaxRateToCounty.TaxTypeID"
                :rules="[(v) => !!v || 'required']"
              ></LuExciseTaxTypes>
            </v-col>
          </v-row>
          <v-row>
            <v-col sm="12">
              <v-checkbox
                label="Is Active"
                v-model="selectedExciseTaxRateToCounty.IsActive"
                :rules="[(v) => v === true || v === false || 'required']"
              ></v-checkbox>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn
            @click="saveExciseTaxRateToCountyDetails"
            :disabled="saving"
            color="primary"
            >Save</v-btn
          >
          <v-btn outlined color="primary" @click="cancelEntry">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script>
import {get, sync, commit, call} from 'vuex-pathify'
import ExciseTaxRateToCounty from '@classes/ExciseTaxRateToCounty'
//templateTODO: import lookup components you plan to use
import LuCounty from '@components/select/a-single/LuCounty'
import LuExciseTaxRates from '@components/select/single/LuExciseTaxRates'
import LuExciseTaxTypes from '@components/select/single/LuExciseTaxTypes'
export default {
  components: {
    //templateTodo: define lookup components you are using
    LuCounty,
    LuExciseTaxRates,
    LuExciseTaxTypes,
  },
  data: () => ({
    dialog: false,
    valid: true,
    selectedExciseTaxRateToCounty: new ExciseTaxRateToCounty(),
    modalText: '',
  }),
  created() {},
  computed: {
    ...get('exciseTaxRateToCounty', ['saving']),
  },
  methods: {
    handleError: call('errors/handleError'),
    ...call('exciseTaxRateToCounty', ['saveExciseTaxRateToCounty']),
    async validate() {
      this.$refs.form.validate()
    },
    editExciseTaxRateToCounty(entry) {
      this.selectedExciseTaxRateToCounty = new ExciseTaxRateToCounty(entry)
      this.modalText = 'Edit Tax Rate To County'
      this.dialog = !this.dialog
    },
    addExciseTaxRateToCounty() {
      this.modalText = 'Insert Tax Rate To County'
      this.selectedExciseTaxRateToCounty = new ExciseTaxRateToCounty()
      this.dialog = !this.dialog
    },
    saveExciseTaxRateToCountyDetails() {
      this.validate().then(() => {
        if (this.valid) {
          //templateTODO: if you want to save related item arrays you will need to add a getSaveData() function to the javascript class and call that instead
          this.saveExciseTaxRateToCounty(
            this.selectedExciseTaxRateToCounty.removeRelated()
          ).then(
            (res) => {
              this.$emit('refresh')
              this.selectedExciseTaxRateToCounty = new ExciseTaxRateToCounty()
              this.$refs.form.resetValidation()
            },
            (err) => {}
          )
          this.dialog = false
        }
      })
    },
    cancelEntry() {
      this.dialog = false
      this.selectedExciseTaxRateToCounty = new ExciseTaxRateToCounty()
      this.$refs.form.resetValidation()
    },
  },
}
</script>
<style></style>
